export default __webpack_public_path__ + "static/media/trampapo_01-05.bcd17bb4.jpg";